import { render, staticRenderFns } from "./RichTextPostView.vue?vue&type=template&id=b7bb46a6&scoped=true&"
import script from "./RichTextPostView.vue?vue&type=script&lang=ts&"
export * from "./RichTextPostView.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextPostView.vue?vue&type=style&index=0&id=b7bb46a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bb46a6",
  null
  
)

export default component.exports